function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#F8F9FB"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43.408 95L24 111.871 29.36 111.871 29.36 128 39.896 128 39.896 115.579 46.92 115.579 46.92 128 57.64 128 57.64 111.871 63 111.871z",
  transform: "translate(-24 -95)"
})));

function SvgHomepageLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 33,
    viewBox: "0 0 39 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageLink);
export default __webpack_public_path__ + "static/media/homepage-link.a45305aa.svg";
export { ForwardRef as ReactComponent };